import { connect } from 'react-redux';
import ContractVehiclesMassRemove from './ContractVehiclesMassRemove';
import { downloadVehiclesChangeTemplate, uploadMassChange, closeResultMessage, downloadMassiveChangeFailedRecords, openConfirmationMessage, closeConfirmationMessage, setMassiveChangeType } from '../../../store/contracts/actions';

export default connect(
  (state) => ({
    vehiclesMassiveChangeRecords: state.contracts.vehiclesMassiveChangeRecords,
    loader: state.contracts.loader,
    resultMessage: state.contracts.resultMessage,
    confirmationMessage: state.contracts.confirmationMessage
  }),
  {
    setMassiveChangeType,
    downloadVehiclesChangeTemplate,
    uploadMassChange,
    closeResultMessage,
    downloadFailedRecords: downloadMassiveChangeFailedRecords,
    openConfirmationMessage,
    closeConfirmationMessage
  }
)(ContractVehiclesMassRemove);
